const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
//const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
const Chat = require("../chat");

class AllergiesModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `component-block module_meds_eng v20 module_med_v20 ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));
    this.contentHash = {};
    this.typingIndicator = null;
    this._element = null;
  }

  mapFormat(value) {
    const _self = this;
    const params = { data: value.values };

    switch (params.data.format) {
      case "allergy-list":
        params.data.values = formatPriorAllergies(params.data.values);
        params.data.format = "list-yes-no";
        params.data.labels = ["allergy", "reaction"];
        params.data.options = {
          buttonName: "Submit",
          alphabetical: true
        };
        break;
      case "selected-list":
        params.data.values = formatAllergyList(params.data.values);
        params.data.format = "list-yes-no";
        params.data.labels = ["allergy", "reaction"];
        params.data.options = {
          button: false,
          alphabetical: true,

          editListOptions: {
            configPopupRemove: {
              title: "Delete",
              content: "Are you sure you want to delete this allergy?"
            },
            configPopupEdit: {
              title: "Update allergy?",
              content: "This will update your selected allergy."
            }
          }
        };
        break;
      default:
    }

    params.data.id = (_self.value || {}).id;

    return new Block(params);
  }

  handle(type, value) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(JSON.parse(JSON.stringify(value || {})));

    if (value.status == 'typing') {
      console.log('typing')
    }

    if (!_elm) return;
    this.elContainer.innerHTML = "";
    this.elContainer.addELM(new Provider({ data: value }));
    //add medication list
    const elemsToAdd = [];

    if (value.values.latestAllergy && !value.values.allergy) {
      elemsToAdd.push(this.drawLastAllergy(value.values.latestAllergy))
    } else if (value.values.allergy && value.values.format !== 'allergy-list') {
      //add list
      let params = {
        values: { format: "selected-list", values: value.values.allergy }
      };
      let list = this.mapFormat(params);
      elemsToAdd.push(list);
    }

    elemsToAdd.push(_elm);

    for (const addEl of elemsToAdd) {

      if(addEl._option && addEl._option._element && addEl._option._element.reset)
        addEl._option._element.reset();

      this.elContainer.addELM(addEl);
    }

    // add show more button
    this.showMore(this.elContainer);


    if (value.status !== "typing"
      && (value.values || {}).format != 'list-yes-no'
      && (value.values || {}).format != 'allergy-list') {
        if((value.values || {}).format === 'singleselect-other' || (value.values || {}).format === 'confirm') {
          const sTo = this.elContainer.offsetTop;
          Scroller.smoothScrollTo(sTo, 200, () => {});
          return;
        }

        Scroller.scrollToEnd(20, () => {
          _elm.focus();
        });
    }
  }

  handleOnMessage(value) {
    //const data = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];
      question.updateAnswer(value.values, this.clearAfterId.bind(this));
    } else if (!this.contentHash[identifier]) {
      component = this.mapFormat(value);
      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
        identsplit = (identifier || "").split("suggestions/");
        identifier = identsplit[0] + identsplit[1];
        component = this.contentHash[identifier][1];
        if (
          value.continue === false &&
          component._option._element.updateSuggestions
        ) {
          this.typingIndicator = null;
          component._option._element.updateSuggestions(
            (value.values || []).suggestions
          );
          return;
        }
      } else {
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else {

      //CA: we need to do this to update the values of the question when you edit medication
      component = this.mapFormat(value);

      this.contentHash[identifier] = [
        Object.keys(this.contentHash).length,
        component
      ];
    }

    if (value.status === "typing" || value.id.indexOf("/") === -1) {
      this.typingIndicator = component;
    }

    return component;
  }


  drawLastAllergy(allergy) {
    const lastAllergy = cELM("div", "meds-edit-wrapper");
    const editBtnWrapper = cELM("div", "edit-wrapper")
    const editButton = cELM("div", "edit-med button", "Edit");
    editBtnWrapper.addELM(editButton)
    const medWrapperDiv = cELM("div", "med-name");
    const medDiv = cELM("div", "", allergy.allergy);
    const medDosageDiv = cELM("div", "med-dosage", "Reaction: " + allergy.reaction);

    medWrapperDiv.addELM(medDiv);
    medWrapperDiv.addELM(medDosageDiv);

    lastAllergy.addELM(medWrapperDiv)
    lastAllergy.addELM(editBtnWrapper)

    editButton.value = allergy.allergy
    editButton.onclick = this.onEditClicked.bind(this)

    return lastAllergy;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]._element);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
  }
  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      elm.defaultOffset = 100;
      ScrollNotification.attachElement(elm);
    }
  }

  scrollToFirstItem() {
    Scroller.scrollToElm(this);
  }

  onDeleteClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: "Delete",
        content: "Are you sure you want to delete this allergy?"
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({
            allergy: value,
            action: "startDelete",
            id: (self.value || {}).id
          });
        } else {
        }
      }
    );
  }

  onEditClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: "Update allergies?",
        content: "This will update your current allergies."
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({
            medication: value,
            action: "startEdit",
            id: (self.value || {}).id
          });
        } else {
        }
      }
    );
  }
}


function formatPriorAllergies(allergy) {
  const list = [];

  if (allergy['priorallergies']) {
    let values = Object.values(allergy['priorallergies'] || {});

    for (let index = 0; index < values.length; index++) {
      list.push({
        status: values[index].status,
        allergy: values[index].allergy,
        medication: values[index].allergy, //to avoid modify listYesNo component
        reaction: 'Reaction: ' + values[index].reaction,
      });
    }
  }

  return list;
}

function formatAllergyList(allergy) {
  const list = [];

  if (allergy['allergies']) {
    let values = Object.values(allergy['allergies'] || {});

    for (let index = 0; index < values.length; index++) {
      list.push({
        status: 'yes',
        allergy: values[index].allergy,
        medication: values[index].allergy, //to avoid modify listYesNo component
        reaction: 'Reaction: ' + values[index].reaction,
        isNewlyAdded: values[index].isNewlyAdded
      });
    }
  }

  if (allergy["no-allergies"]) {
    let values = Object.values(allergy["no-allergies"] || {});

    for (let index = 0; index < values.length; index++) {
      list.push({
        status: "no",
        allergy: values[index].allergy,
        medication: values[index].allergy, //to avoid modify listYesNo component
        reaction: 'Reaction: ' + values[index].reaction,
        isNewlyAdded: values[index].isNewlyAdded
      });
    }
  }
  return list;
}

module.exports = AllergiesModule;
